// «Πιάτα ημέρας» από το μενού του ταμία (δικαίωμα daily_dishes_manage, διακόπτης του καταστήματος): η ίδια
// οθόνη «Σήμερα» με τη διαχείριση, σε παράθυρο για οθόνη αφής. Ο κατάλογος του ταμείου ανανεώνεται μόνος του
// με κάθε αλλαγή (announceDailyDishesChanged + socket), χωρίς F5.

import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { UtensilsCrossed, X } from 'lucide-react';
import { useBackdropDismiss } from '../../utils/backdropDismiss';
import DailyDishesManager from './DailyDishesManager';

interface Props {
  storeId: number;
  onClose: () => void;
}

const DailyDishesModal: React.FC<Props> = ({ storeId, onClose }) => {
  const { t } = useTranslation(['dailyDishes']);
  const backdrop = useBackdropDismiss(onClose);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      // Ανοιχτή επιβεβαίωση από πάνω: εκείνη κλείνει πρώτη (το δικό της κουμπί).
      if (document.querySelector('[data-testid="daily-clear-confirm"]')) return;
      onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[80] grid place-items-center bg-black/50 p-0 sm:p-4" {...backdrop}>
      <div role="dialog" aria-modal="true" aria-labelledby="daily-dishes-modal-title" data-testid="daily-dishes-modal"
        className="flex h-full w-full max-w-[860px] flex-col overflow-hidden bg-surface-1 shadow-xl sm:h-auto sm:max-h-[94vh] sm:rounded-2xl sm:border sm:border-line">
        <div className="flex items-center gap-3 border-b border-line px-5 py-4">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brand-soft text-brand">
            <UtensilsCrossed className="h-5 w-5" aria-hidden="true" />
          </span>
          <h2 id="daily-dishes-modal-title" className="min-w-0 flex-1 text-[19px] font-bold text-t1">{t('dailyDishes:title')}</h2>
          <button type="button" aria-label={t('dailyDishes:modal.close')} onClick={onClose}
            className="flex h-11 w-11 items-center justify-center rounded-xl bg-surface-2 text-t2 hover:bg-surface-3">
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
        <div className="min-h-0 flex-1 overflow-y-auto px-4 py-4 sm:px-5">
          <DailyDishesManager storeId={storeId} variant="cashier" />
        </div>
      </div>
    </div>
  );
};

export default DailyDishesModal;
